import React from 'react';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Check, CrossSymetric } from '../../Icons';

export const MessageTypes = {
    ERROR: 'error',
    SUCCESS: 'success',
};

const Message = ({ styles, type, messageId }) => {
    const [opacity, setOpacity] = React.useState(0);

    React.useEffect(() => {
        setOpacity(1);

        return () => setOpacity(0);
    }, []);

    return (
        <div style={{ opacity }} className={styles.container}>
            {type === MessageTypes.ERROR ? (
                <CrossSymetric className={styles.icon} />
            ) : (
                <Check className={styles.icon} />
            )}
            <span className={styles.text}>
                <FormattedMessage id={messageId} />
            </span>
        </div>
    );
};

Message.propTypes = {
    styles: PropTypes.shape().isRequired,
    messageId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(MessageTypes)).isRequired,
};

export default Message;
